import { render, staticRenderFns } from "./disbursements.vue?vue&type=template&id=418847f8"
import script from "./disbursements.vue?vue&type=script&lang=ts"
export * from "./disbursements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports